import { render, staticRenderFns } from "./live-video.vue?vue&type=template&id=a5fb5d56&scoped=true"
import script from "./live-video.vue?vue&type=script&lang=js"
export * from "./live-video.vue?vue&type=script&lang=js"
import style0 from "./live-video.vue?vue&type=style&index=0&id=a5fb5d56&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5fb5d56",
  null
  
)

export default component.exports